import { render, staticRenderFns } from "./serve2.vue?vue&type=template&id=3ce8aa00&scoped=true"
import script from "./serve2.vue?vue&type=script&lang=js"
export * from "./serve2.vue?vue&type=script&lang=js"
import style0 from "./serve2.vue?vue&type=style&index=0&id=3ce8aa00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce8aa00",
  null
  
)

export default component.exports